import React, { useEffect } from 'react';
import SEO from '../utils/SEO';
import BannerBlock from '../components/complex/bannerBlock/bannerBlock';
import FAQ_List from '../components/complex/FAQ_List/FAQ_List';
import { startLoader } from '../components/common/Loader';
import { userActions } from '../redux/actions/user.actions';
import { connect } from 'react-redux';

const FAQ = ({ getMeta, getFAQ, getUsefulContacts, ...props }) => {
  useEffect(() => {
    getMeta('FAQ');
    startLoader();
    getFAQ();
    getUsefulContacts();
  }, []);

  const metaData = props.metaData?.res;
  const bannerData = props.faqData?.items?.res?.banner;
  const listData = props.faqData?.items?.res?.data;
  const contactData = props.contactData?.items?.data;
  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />

      <BannerBlock
        data={bannerData}
        pageName='faqBanner'
        color='white'
        position='left'
        fullHeight
        scrollTo={{ elementId: 'faq_list' }}
      />
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <FAQ_List data={listData} contactData={contactData} />
    </>
  );
};

function mapState (state) {
  return {
    faqData: state.getFAQ,
    contactData: state.getUsefulContacts,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getMeta: userActions.getMetaData,
  getFAQ: userActions.getFAQ,
  getUsefulContacts: userActions.getUsefulContacts,
};

FAQ.fetchMeta = () => {
  return actionCreators.getMeta('FAQ');
};
FAQ.serverFetch = actionCreators.getFAQ;

export default connect(mapState, actionCreators)(FAQ);
